import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import httpClient from "../../utils/httpClient";
import { productAPIDataType } from "../../pages/CTProductCostSetup/ProductDataType";
interface RequestDetails {
  productId: string;
}

interface ProductDetailsState {
  isLoading: boolean;
  data: {
    Code: number;
    Status: string;
    Message: string;
    Data: productAPIDataType | null;
  } | null;
  error: string | null;
}

const initialState: ProductDetailsState = {
  isLoading: true,
  data: null,
  error: null,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchProductDetailsData = createAsyncThunk<any, RequestDetails>(
  "CTProductDetailsSlice/fetchProductDetailsData",
  async (requestDetails, thunkApi) => {
    try {
      const response = await httpClient.post("/product", {
        ProductId: requestDetails.productId,
        Action: "retrieve",
      });

      if (response.status != 200 || response.data.Status !== "success") {
        if (response.data.Status == "error") {
          return thunkApi.rejectWithValue({
            message: response.data.Message,
          });
        } else {
          return thunkApi.rejectWithValue({
            message: "Failed to get product details",
          });
        }
      }
      return response.data;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      console.log("🚀 ~ error:", error);
      if (
        error?.response?.data?.Data[0]?.includes("Product ID does not exist")
      ) {
        return thunkApi.rejectWithValue({
          message: "404",
        });
      }
      return thunkApi.rejectWithValue({
        message: "Failed to get product details",
      });
    }
  },
);

const CTProductDetailsSlice = createSlice({
  name: "CTProductDetailsSlice",
  initialState,
  reducers: {
    resetProductDetailState: (state) => {
      state.isLoading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductDetailsData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.data = null;
      })
      .addCase(
        fetchProductDetailsData.fulfilled,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (state, action: PayloadAction<any>) => {
          if (action.payload.Status == "success") {
            state.isLoading = false;
            state.data = action.payload;
            state.error = null;
          } else if (action.payload.Status == "error") {
            state.isLoading = false;
            state.data = null;
            state.error = action.payload.message;
          }
        }
      )
      .addCase(
        fetchProductDetailsData.rejected,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.data = null;
          state.error = action.payload.message;
        }
      );
  },
});

export const { resetProductDetailState } = CTProductDetailsSlice.actions;

export default CTProductDetailsSlice.reducer;
